import { routersPath } from '@router/routes-path'
import { adminTabs, ITabs } from '@components/Header/AdminHeader/adminTabs'
import { useUserRole } from '@store/selectors/auth'
import React, { useMemo } from 'react'
import { EUserRoles } from '@enums/roles'
import { bossTabs } from '@components/Header/AdminHeader/bossTabs'
import { accountantTabs } from '@components/Header/AdminHeader/accountantTabs'
import { telephonyTabs } from '@components/Header/AdminHeader/telephonyTabs'
import { useNavigate } from 'react-router'

const useCurrentTab = (path: string) => {
  const role = useUserRole()
  const navigate = useNavigate()

  if (!role) navigate(routersPath.LOGIN_PAGE)

  const tabs = useMemo(() => {
    switch (role) {
      case EUserRoles.SUPER_ADMIN: {
        return adminTabs
      }
      case EUserRoles.BOSS: {
        return bossTabs
      }
      case EUserRoles.ACCOUNTANT: {
        return accountantTabs
      }
      case EUserRoles.PHONE_OPERATOR: {
        return telephonyTabs
      }
    }
  }, [role])

  const findIndex = (path: string, tabs: ITabs[]) => {
    return tabs?.findIndex((el) => el.pages.includes(path as routersPath))
  }

  return findIndex(path, tabs)
}

export default useCurrentTab
